export default __webpack_public_path__ + "static/media/about1.40d966e7.jpg";